export default "__VITE_ASSET__ef8256c6__"